import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "./AppointmentCard.css";
import "../../Components/ApproveAppointment/ApproveAppointment.css";
import { t } from "../../Utils/translate";
import classNames from "classnames";
import "react-js-dialog-box/dist/index.css";
import Widgets from "../index";
import CustomModal from "../CustomModal/CustomModal";
import moment from "moment-timezone";
import clinicService from "../../Services/clinicService";
import Component from "../../Components";
import strings from "../../Utils/strings";
import toast from "react-hot-toast";
import { isToday, isPast } from "date-fns";
import authService from "../../Services/authService";
import { useDispatch } from 'react-redux';
import { waiveOffAppointment } from '../../modules/WaiverOff/appointmentsThunk';
 
const AppointmentCard3 = ({ appointment, isSelected, selectedAppointmentIndex, setSelectedAppointmentIndex, onClick, requestApp, translationKey, refreshAppointments, appointmentId }) => {
  const navigate = useNavigate();
  const [dataList, setDataList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalBodyText, setModalBodyText] = useState("");
  const [btnPvalue, setbtnPvalue] = useState("");
  const [btnNvalue, setbtnNvalue] = useState("");
  const [showMeeting, setShowMeeting] = useState(false);
  const [localIsSelected, setLocalIsSelected] = useState(isSelected);
  const [modalStatus, setModalStatus] = useState();
  const [session, setSession] = useState("");
  const [zoomToken, setZoomToken] = useState("");
  const [modalAction, setModalAction] = useState("");
  const [showRrDoc, setShowRrDoc] = useState(false);
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [waiveOffReason, setWaiveOffReason] = useState("");
  const [waiveOffError, setWaiveOffError] = useState("");
 
  const dispatch = useDispatch();
 
const handleWaiveOffSubmit = async () => {
  const trimmedReason = waiveOffReason.trim(); // removes leading and trailing spaces
  if (trimmedReason.length < 10) {
    toast.error(t("waiveOffErrorMsg"))
    return false;
  }
 
  try {
    await dispatch(waiveOffAppointment({ appointmentId: appointment._id, waiveOffReason })).unwrap();
    setShowReasonModal(false);
    setWaiveOffReason("");
    refreshAppointments();
    return true;
  } catch (error) {
    toast.error(error || t("waiveOffFailed") || "Failed to waive off");
    return false;
  }
};
 
  const isSubmitDisabled = waiveOffReason.trim().length < 10;
 
  const [autoJoin, setAutoJoin] = useState(false);
  useEffect(() => {
    if (showMeeting) {
      navigate(
        `${strings.navigation.zoom}?session=${encodeURIComponent(session)}&zoomToken=${encodeURIComponent(zoomToken)}&doctorName=${
          appointment.doctor.name
        }&doctorId=${appointment.doctor._id}&appointmentId=${appointment._id}&date=${appointment.startTime}`,
      );
    }
  }, [showMeeting]);
 
  useEffect(() => {
    setLocalIsSelected(isSelected);
  }, [isSelected]);
 
  const handleClick = () => {
    const isMobile = window.innerWidth <= 768;
    if (!isMobile) {
      if (!localIsSelected) {
        setLocalIsSelected(true);
        if (onClick) onClick();
      }
    } else {
      setLocalIsSelected((prev) => !prev);
      if (onClick) onClick();
    }
  };
  const acceptAppointmentCall = async () => {
    let body = {
      status: modalAction === "accept" ? "CONFIRMED" : "REJECTED",
    };
    if (modalStatus === true) {
      try {
        let response;
        if (authService.getIsDoctorLogin() === "true") {
          response = await clinicService.docAcceptAppointment(appointment._id, body);
        } else if (authService.getIsDoctorLogin() === "false") {
          response = await clinicService.acceptAppointment(appointment._id, body);
        }
 
        if (response.status === "success") {
          const acceptedAppointmentId = appointment._id;
          await refreshAppointments();
 
          setSelectedAppointmentIndex(acceptedAppointmentId);
        }
      } catch (error) {
        console.error("Error while accepting appointment:", error);
      }
    }
  };
 
  useEffect(() => {
    acceptAppointmentCall();
    if (showModal === false) {
      setModalStatus(false);
    }
  }, [modalStatus]);
  const handleStartMeeting = () => {
    // setShowMeeting(true);
    // setAutoJoin(true);
    getZoomToken();
  };
 
  const handleModalOpen = (title, bodyText, nbtnvalue, pbtnvalue, action) => {
    setModalTitle(title);
    setModalBodyText(bodyText);
    setShowModal(true);
    setbtnNvalue(nbtnvalue);
    setbtnPvalue(pbtnvalue);
    setModalAction(action);
  };
 
  const handleModalClose = () => {
    setShowModal(false);
  };
 
  function renderData() {
    let arr = [];
    for (let key in appointment.data) {
      if (appointment.data.hasOwnProperty(key)) {
        var val = appointment.data[key];
        arr.push(val);
      }
    }
    setDataList(arr);
  }
 
  useEffect(() => {
    renderData();
  }, []);
 
  const todayOrPastDate = (startTime) => {
    const startDate = new Date(startTime);
    const now = new Date();
    startDate.setHours(0, 0, 0, 0);
    now.setHours(0, 0, 0, 0);
    return startDate <= now;
  };
 
  const getZoomToken = async () => {
    const appId = appointment._id;
    try {
      let response;
      if (authService.getIsDoctorLogin() === "true") {
        response = await clinicService.docGetZoomToken(appId);
      } else if (authService.getIsDoctorLogin() === "false") {
        response = await clinicService.getZoomToken(appId);
      }
      if (response.status === "success") {
        setSession(response.data.session);
        setZoomToken(response.data.token);
        setTimeout(() => {
          setShowMeeting(true);
        }, 200);
      }
      if (response.status === 400) {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("error", error);
    }
  };
 
  // if (showMeeting) {
  //   return <Component.NewZoom session={session} zoomToken={zoomToken} />;
  // }
  return (
    <React.Fragment>
      <div
        className={classNames("appointment-card", {
          "appointment-card-border ": localIsSelected,
        })}
        style={{ marginBottom: "15px" }}
        onClick={handleClick}
      >
        <div>
          <div className="card-grid">
            <div className="card-item ">
              {appointment.patient.profilePhoto ? (
                <img
                  className="card-profile-container"
                  src={appointment.patient.profilePhoto}
                  alt={`${appointment.patient.fullName}'s profile`} // Provide an alt text for accessibility
                />
              ) : (
                <div className="smile-icon">
                  <i className="ri-user-smile-line" />
                </div>
              )}
            </div>
            <div className="card-item">
              <div className="info-container">
                <div>
                  <span className="name-flag-view">
                    <h4 data-toggle="tooltip" title={"Patient Name"} className="appointment-details-subtitles font-600">
                      {appointment.patient.fullName}
                      {/*subtitle*/}
                    </h4>
                  </span>
                  {dataList.map((item, i) => {
                    return (
                      <div key={i}>
                        <span className="appointment-details-content">{item}</span>
                        {i < dataList.length ? <br /> : ""}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="card-item chat-and-status-view">
              <div>
                <Widgets.AppointmentStatus
                  label={
                    appointment.status === "WAITING_FOR_CLINIC_CONFIRMATION"
                      ? t("pending")
                      : appointment.status === "CONFIRMED"
                        ? t("confirmed")
                        : appointment.status === "STARTED"
                          ? t("STARTED")
                          : appointment.status === "SCHEDULED"
                            ? t("scheduled")
                            : appointment.status === "COMPLETED"
                              ? t("COMPLETED")
                              : appointment.status
                  }
                  labelType={appointment.appointmentStatus}
                />
              </div>
            </div>
          </div>
          <div className="d-flex">
            <div className="card-footer-span mt-1 ml-[1.7rem]">
              {t("hnNum")}: {appointment.hnNumber}
            </div>
          </div>
          <div className="card-footer-span mt-1 ml-[1.7rem]">
            {appointment.patient.age} {t("labelYears")}, {t(appointment.patient.gender)}
          </div>
          <div className="card-footer-span mt-1 ml-[1.7rem]">
            +{appointment.patient.countryCode} {appointment.patient.phoneNumber}
          </div>
          <div className="d-flex ml-[1.7rem]" style={{ flexWrap: "wrap" }}>
            {appointment.symptoms.map((item, i) => (
              <div key={i} className="card-footer-span mt-1 mr-[5px]">
                {item}
                {appointment.symptoms.length > i + 1 && ","}
              </div>
            ))}
          </div>
        </div>
        <div className="appointment-details-divider" />
        <div className="app-card-footer">
          <div className="w-[30%]">
            <span className="card-footer-span">{t("dateLabel")}</span>
            <br />
            <span className="card-footer-data">{moment(appointment.startTime).format("DD/MM/YYYY")}</span>
          </div>
          <div className="w-[30%]">
            <span className="card-footer-span">{t("Time")}</span>
            <br />
            <span className="card-footer-data">{moment(appointment.startTime).format("HH:mm")}</span>
          </div>
          <div className="w-[40%]">
            <span className="card-footer-span">{t("Doctor")}</span>
            <br />
            <span data-toggle="tooltip" title={"doctorname"} className={classNames("card-footer-data")}>
              {appointment.doctor.name}
            </span>
          </div>
        </div>
      { (appointment.status === "WAITING_FOR_CLINIC_CONFIRMATION" || appointment.status === "CONFIRMED") &&  <div className="appointment-request-btn-view">
          <button className="appointment-request-btn accept-btn" onClick={() => setShowRrDoc(!showRrDoc)}>
            {t("reResg")}
          </button>
        </div> }
        {authService.getIsDoctorLogin() !== "true" && (appointment.status === "SCHEDULED" || appointment.status === "STARTED") &&  <div className="appointment-request-btn-view">
          <button className="appointment-request-btn accept-btn" onClick={() => setShowRrDoc(!showRrDoc)}>
            {t("reResg")}
          </button>
        </div>}
        {showRrDoc && <Widgets.Reassigndoc appointment={appointment} showModal={showRrDoc} refreshAppointments={refreshAppointments} setShowModal={setShowRrDoc} handleCancel={()=> setShowRrDoc(false)} restrictToSameDoctor={requestApp === false && (appointment.status === "SCHEDULED" || appointment.status === "STARTED")} />}
        {appointment.status === "WAITING_FOR_CLINIC_CONFIRMATION" ? (
          <div className="appointment-request-btn-view">
            <button className="appointment-request-btn accept-btn" onClick={() => handleModalOpen(t("Accept"), t("confirmAcceptAppointment"), t("waiveOffAndAccept"), t("accept"), "accept")}>
              {t("Accept")}
            </button>
            <button className="appointment-request-btn reject-btn" onClick={() => handleModalOpen(t("reject"), t("confirmRejectAppointment"), t("No"), t("Yes"), "reject")}>
              {t("reject")}
            </button>
{showModal && (
  <div className="custom-modal-overlay">
    <CustomModal
      show={showModal}
      handleClose={handleModalClose}
      title={modalTitle}
      bodyText={modalBodyText}
      negativebtnvalue={btnNvalue}
      positivebtnvalue={btnPvalue}
      modalBtnStatus={(status) => {
        if (
          !status &&
          modalAction === "accept" &&
          btnNvalue === t("waiveOffAndAccept")
        ) {
          setShowModal(false);
          setShowReasonModal(true);
        } else {
          setModalStatus(status);
        }
      }}
    />
  </div>
)}
 
{showReasonModal && (
  <div className="custom-modal-overlay">
    <CustomModal
      show={showReasonModal}
      handleClose={() => {
        setShowReasonModal(false);
        setWaiveOffReason("");
        setWaiveOffError("");
      }}
      title={t("waiveOffReason") || "Reason for Waive Off"}
      bodyText={
        <>
          <textarea
            className="waiveoff-textarea"
            value={waiveOffReason}
            onChange={(e) => {
              setWaiveOffReason(e.target.value);
              if (e.target.value.trim().length >= 10) {
                setWaiveOffError("");
              } else {
                setWaiveOffError(t("waiveOffErrorMsg") || "Minimum 10 characters required");
              }
            }}
            placeholder={t("waiveOffReasonPlaceholder") || "Enter your reason here..."}
            style={{ width: "100%", height: "80px", marginBottom: "12px" }}
          />
          {waiveOffError && (
            <div style={{ color: "red", fontSize: "0.875rem", marginBottom: "12px" }}>
              {waiveOffError}
            </div>
          )}
        </>
      }
      negativebtnvalue={t("cancel") || "Cancel"}
      positivebtnvalue={t("submit") || "Submit"}
      modalBtnStatus={async (status) => {
        if (status) {
          if (waiveOffReason.trim().length < 10) {
            setWaiveOffError(t("waiveOffErrorMsg") || "Minimum 10 characters required");
            return;
          }
          const success = await handleWaiveOffSubmit();
          if (success) toast.success(t("waiveOffAccepted") || "Waive off reason submitted");
        }
        setShowReasonModal(false);
        setWaiveOffReason("");
        setWaiveOffError("");
      }}
    />
    <style>
      {`
        /* Disable and grey out positive button on waive off modal */
        .modal-footer button.btn-success {
          pointer-events: ${waiveOffReason.trim().length < 10 ? "none" : "auto"} !important;
          opacity: ${waiveOffReason.trim().length < 10 ? 0.5 : 1} !important;
          cursor: ${waiveOffReason.trim().length < 10 ? "not-allowed" : "pointer"} !important;
          background-color: ${waiveOffReason.trim().length < 10 ? "gray" : "green"} !important;
          border-color: ${waiveOffReason.trim().length < 10 ? "gray" : "green"} !important;
        }
      `}
    </style>
  </div>
)}
          </div>
        ) : (
          <div className="call-btn-view">
            {todayOrPastDate(appointment.startTime) && (appointment.status === "STARTED" || appointment.status === "SCHEDULED") && (
              <button className="call-btn call-btn-start custom-call-btn" onClick={handleStartMeeting}>
                {t("start")}
              </button>
            )}
          </div>
        )}
      </div>
      <div id="meetingSDKElement"></div>
    </React.Fragment>
  );
};
 
export default AppointmentCard3;